import * as React from "react";
import { ProjectCarousel } from "@/components/ProjectCarousel";
import { PROJECTS } from "@/constants/projects";

export const References = () => (
  <ProjectCarousel
    id="referenzen"
    className="border-t border-border/60"
    eyebrow="Referenzen"
    title={
      <>
        Websites, die für ihre
        <br className="hidden sm:block" /> Unternehmen arbeiten.
      </>
    }
    description="Live-Projekte aus unterschiedlichen Branchen – zieh die Collage zur Seite oder klick ein Fenster an, um die Website zu öffnen."
    items={PROJECTS}
    footerText="Über 60 umgesetzte Projekte · vom Handwerksbetrieb bis zur Akademie"
    footerLink={{
      label: "Deine Website als nächstes Projekt",
      href: "#kontakt",
    }}
  />
);
